import { Avatar, AvatarFallback, AvatarImage } from '@components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@components/ui/dropdown-menu';
import { hasElevatedRights, type StudioUser } from '@stratumn/studio-shared';
import { CircleUser, LayoutDashboard, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ACCOUNT_UI_URL } from '@/utils/constants';
import { logout } from '@/utils/logout';

type HeaderUserMenuProps = {
  user: StudioUser;
};

export const HeaderUserMenu = ({ user }: HeaderUserMenuProps) => {
  const navigate = useNavigate();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Avatar className="h-9 w-9 cursor-pointer">
          <AvatarImage
            src={
              user?.avatar != null
                ? user?.avatar
                : 'https://www.w3schools.com/howto/img_avatar.png'
            }
          />
          {user && (
            <AvatarFallback>{`${user.firstName?.[0]}${user?.lastName?.[0]}`}</AvatarFallback>
          )}
        </Avatar>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="mr-2 border border-gray-200 border-solid">
        <DropdownMenuLabel>
          <div className="flex flex-col space-y-1">
            <p className="font-medium text-sm leading-none">
              {user.firstName} {user.lastName}
            </p>
            <p className="text-muted-foreground text-xs leading-none">
              {user.email}
            </p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() => (location.href = ACCOUNT_UI_URL)}
          >
            <CircleUser className="mr-2 size-4 text-muted-foreground" />
            Account
          </DropdownMenuItem>
          {hasElevatedRights(user) && (
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={() => navigate('/admin/organizations')}
            >
              <LayoutDashboard className="mr-2 size-4 text-muted-foreground" />
              Admin Dashboard
            </DropdownMenuItem>
          )}
          <DropdownMenuItem className="cursor-pointer" onClick={() => logout()}>
            <LogOut className="mr-2 size-4 text-muted-foreground" />
            Logout
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
